import {useEffect, FunctionComponent, ReactElement} from 'react';
import {reportEvent} from '../reportEvent';
import {EventType} from '../../server/@types';

type Props = {
    /** name of error report */
    name: string;
    /** any data to log server side, useful for Splunking and such */
    logData?: object;
    children?: ReactElement;
};

/**
 * Reports an event and renders any children.
 */
const makeEventReporter = (type: EventType): FunctionComponent<Props> => {
    const Component = ({
        name,
        logData,
        children
    }: Props): ReactElement | null => {
        useEffect(() => {
            reportEvent({name, logData}, type);
        }, [name]);
        return children || null;
    };
    Component.displayName = `${type.charAt(0)}${type
        .slice(1)
        .toLowerCase()}Report`;
    return Component;
};

export const SuccessReport = makeEventReporter('SUCCESS');

export const ErrorReport = makeEventReporter('ERROR');
